module.exports = __webpack_public_path__ + "static/img/brees-2018-slide-7.04ea79c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-slide-7.jpg
// module id = vKBM
// module chunks = 1